import { AvisGoogle } from '@components/avis-google/models';
import { imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const avisGoogleMock = (withTestimonial = false): Block<AvisGoogle> => ({
  type: 'avis-google',
  data: {
    title: {
      text: `Si vous venez de la part de Marco, Zaza ou Flo, [[c'est qu'on a fait le job]]`,
      as: 'h2',
    },
    reviewStats: {
      totalReviews: 63443,
      averageRating: 4.8,
    },
    buttonAvis: `Voir tous les avis`,
    cta: {
      label: `Voir toutes les cuisines clients`,
      url: '/mock-toutes-nos-cuisines',
    },
    image: imageMock,
    testimonial: withTestimonial
      ? {
          text: `Nous avons choisi SoCoo’c pour le rapport qualité/prix que nous trouvons très raisonnable et nos échanges avec les équipes.`,
          author: `Véronique M.`,
          url: `/mock-vero-avis`,
        }
      : undefined,
    popinTitle: {
      text: `Tous nos avis Google :`,
      as: 'span',
    },
    gtmConfigBtnReviews: {
      event: 'click_cta_avis_value',
      group: 'avis',
      description: 'avis depuis {{page}}',
      context: 'clic pour ouvrir panel avis',
    },
  },
});
